import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore } from "redux";
import rootReducer from "./reducers";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "antd/dist/antd.css";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import moment from "moment";

import "./i18n";
import i18n from "./i18n";

serviceWorker.unregister();

// Performance tracking for production mode
if (process.env.REACT_APP_PRODUCTION === true) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DNS,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

const store = createStore(rootReducer);

i18n.changeLanguage("cs");
moment.defaultFormat = "LL";

// This is confirmed as a best practice
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
